/* eslint-disable @typescript-eslint/quotes */
export const knownPreambles = {
	'This message is in MIME format.': true,
	'This is an S/MIME signed message': true,
	'This is a message in MIME Format.': true,
	'This is a multipart MIME message.': true,
	'This is a multi-part message in MIME format': true,
	'This is a multipart message in MIME format.': true,
	'This is a multi-part message in MIME format.': true,
	'This is a multi-part message in MIME format...': true,
	'You will not see this in a MIME-aware mail reader.': true,
	'This is an OpenPGP/MIME signed message (RFC 4880 and 3156)': true,
	'This is a cryptographically signed message in MIME format.': true,
	'Your mail reader is not capable of displaying this MIME message.': true,
	'X-Mailer: Mailer by Oracle UTL_SMTP This is a multi-part message in MIME format.': true,
	'This is a multi-part message in MIME format. Your email application may not support this format.':
		true,
	'This is a message in MIME Format. If you see this, your mail reader does not support this format.':
		true,
	'This is a message in Mime Format. If you see this, your mail reader does not support this format.':
		true,
	'This is a MIME-formatted message. Portions of this message may be unreadable without a MIME-capable mail program.':
		true,
	'This message is in MIME format. Since your mail reader does not understand this format, some or all of this message may not be legible.':
		true,
	'> This message is in MIME format. Since your mail reader does not understand this format, some or all of this message may not be legible.':
		true,
	'This message is in MIME format. The first part should be readable text, while the remaining parts are likely unreadable without MIME-aware tools.':
		true,
	'This is a MIME 1.0 compliant message. If you are able to see this message, your user agent is not MIME compliant. You will need an alternative mail viewer to read this message in its entirety.':
		true,
	'This is a MIME message. If you are reading this text, you may want to consider changing to a mail reader or gateway that understands how to properly handle MIME multipart messages. If there are formatting issues or issues with the attachments, please forward a copy of this email to: cbemail_issue@careerbuilder.com for further evaluation.':
		true,
	'NOTE: You are reading this note because your email program does not support messages in multi-part "MIME" format (you can see the plain text version of the message, but the HTML version is garbled). The best solution to this problem is to upgrade to an email program that supports MIME. If you can\'t do that, then just ignore the part of this message that is improperly displayed by your current email program.':
		true,

	"This document is a Single File Web Page, also known as a Web Archive file. If you are seeing this message, your browser or editor doesn't support Web Archive files. Please download a browser that supports Web Archive, such as Windows\u00ae Internet Explorer\u00ae.":
		true,
	"This document is a Single File Web Page, also known as a Web Archive file. If you are seeing this message, your browser or editor doesn't support Web Archive files. Please download a browser that supports Web Archive.":
		true,
	'Dit document is een gecombineerd webpaginabestand, ook wel webarchiefbestand genoemd. Als dit bericht wordt weergegeven, worden webarchiefbestanden niet ondersteund door de browser of editor. Download een browser die webarchieven ondersteunt, bijvoorbeeld Windows\u00ae Internet Explorer\u00ae.':
		true,

	"> THIS IS A MESSAGE IN 'MIME' FORMAT.  Your mail reader does not support MIME. > Please read the first section, which is plain text, and ignore the rest.":
		true,

	'Dies ist eine mehrteilige Nachricht im MIME-Format.': true,
};
